import { render } from "./NoPageFound.vue?vue&type=template&id=dd89ef14&scoped=true"
import script from "./NoPageFound.vue?vue&type=script&lang=js"
export * from "./NoPageFound.vue?vue&type=script&lang=js"

import "./NoPageFound.vue?vue&type=style&index=0&id=dd89ef14&scoped=true&lang=css"

import exportComponent from "/home/runner/work/tribuk-ui/tribuk-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd89ef14"]])

export default __exports__